import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Iteams from '../Components/Iteams/Iteams'
import Footer from '../Components/Footer/Footer'

const Home = () => {
  return (
    <div>
      <Navbar/>
      <Iteams/>
      <Footer/>
    </div>
  )
}

export default Home
